module.exports = __webpack_public_path__ + "static/media/logo_cn_invert_en.756384ac.svg";